export default {
	objToQueryStr(obj, arrDelim) {
	    arrDelim = arrDelim || ";";
	    if(!obj) return '';
        const query  = Object.keys(obj)
            .map(k => {
                //e.g. using default arrDelim  {k: ["one", "two,three"]} --> k=one;two,three
                let val = Array.isArray(obj[k]) ? obj[k].join(arrDelim) : obj[k];
                return k + '=' + encodeURIComponent(val)
            }).join('&');

        return '?' + query;
    }
}


// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/Utils.js